import { render, staticRenderFns } from "./GraficaCursoRegular.vue?vue&type=template&id=40d9cbfc&"
import script from "./GraficaCursoRegular.vue?vue&type=script&lang=js&"
export * from "./GraficaCursoRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports